export const SETS = [
  {
    id: 'base', type: 'base', title: 'BASE SET — 100 CARDS',
    cards: [
      {n:'1', name:'Speeder Bike Chase', artist:'June Brigman'},
      {n:'2', name:'The Light of Padmé Amidala', artist:'Marcia Dye'},
      {n:'3', name:'The Droids', artist:'Dave Dorman'},
      {n:'4', name:'Frozen in Carbonite', artist:'Dale Keown'},
      {n:'5', name:'The Max Rebo Band', artist:'Karl Kesel'},
      {n:'6', name:'An Oversized Presence', artist:'Jean Moebius Giraud'},
      {n:'7', name:"The Emperor's Royal Guards", artist:'Jerome Moore'},
      {n:'8', name:'The Rancor', artist:'Jason Palmer'},
      {n:'9', name:'Darth Vader', artist:'George Pratt'},
      {n:'10', name:'T-16 Skyhopper', artist:'Ken Steacy'},
      {n:'11', name:'A Dangerous Boba Fett', artist:'Brian Stelfreeze'},
      {n:'12', name:'Warrior Ewok', artist:'William Stout'},
      {n:'13', name:'Jawas', artist:'Greg Theakston'},
      {n:'14', name:'Chewbacca', artist:'Russell Walks'},
      {n:'15', name:'Imperial Snowtroopers', artist:'Al Williamson'},
      {n:'16', name:'Mos Eisley Cantina', artist:'Bruce Zick'},
      {n:'17', name:'IG-88 on the Attack', artist:'Karl Altstaetter'},
      {n:'18', name:"Boba Fett's Starship", artist:'Joe DeVito'},
      {n:'19', name:'Aurra Sing on Tatooine', artist:'Darrin Pepe'},
      {n:'20', name:'Triple Threat', artist:'Kyle Babbit'},
      {n:'21', name:'"I Love You"', artist:'Rebecca Guay'},
      {n:'22', name:'A Dark Presence', artist:'Matt Haley'},
      {n:'23', name:'Larger than Life', artist:'Jack Kirby'},
      {n:'24', name:'Crushing the Rebels', artist:'Walter McDaniel'},
      {n:'25', name:'Rule of Two', artist:'Nelson'},
      {n:'26', name:'Forsake the Dark Side', artist:'Hoang Nguyen'},
      {n:'27', name:'AT-ST', artist:"Kevin O'Neill"},
      {n:'28', name:'Leap of Faith', artist:'Zina Saunders'},
      {n:'29', name:'The Four Jedi', artist:'Greg and Tim Hildebrandt'},
      {n:'30', name:"Galaxy's Edge", artist:'Arthur Adams'},
      {n:'31', name:'Escaping the AT-STs', artist:'Dave Dorman'},
      {n:'32', name:'Boba Fett', artist:'Brett Booth'},
      {n:'33', name:'New Friends', artist:'Scott Neely'},
      {n:'34', name:'Luke Skywalker', artist:'Jerry Vanderstelt'},
      {n:'35', name:'Leia Organa', artist:'Jerry Vanderstelt'},
      {n:'36', name:'Han Solo', artist:'Jerry Vanderstelt'},
      {n:'37', name:'Darth Sidious', artist:'Steve Chorney'},
      {n:'38', name:'Qui-Gon Jinn', artist:'Steve Chorney'},
      {n:'39', name:'Anakin Skywalker', artist:'Steve Chorney'},
      {n:'40', name:'Padmé Amidala', artist:'Steve Chorney'},
      {n:'41', name:'Jango Fett', artist:'Steve Chorney'},
      {n:'42', name:'Mace Windu', artist:'Steve Chorney'},
      {n:'43', name:'The Empire on Hoth', artist:'Brian Rood'},
      {n:'44', name:'Yoda on Dagobah', artist:'Doug Cowan'},
      {n:'45', name:"A Padawan's Challenge", artist:'Grant Gould'},
      {n:'46', name:'Teaching The Younglings', artist:'Joe Corroney'},
      {n:'47', name:'Call to Vengeance', artist:'Ken Steacy'},
      {n:'48', name:'Empire and Rebellion', artist:'Jerry Vanderstelt'},
      {n:'49', name:'Republic: Unite', artist:'Joe Corroney'},
      {n:'50', name:'Rebellion: Celebrate', artist:'Joe Corroney'},
      {n:'51', name:'New Republic: Together', artist:'Joe Corroney'},
      {n:'52', name:'Enlist Today', artist:'Cliff Chiang'},
      {n:'53', name:'Loose Lips', artist:'Cliff Chiang'},
      {n:'54', name:'Rebuild the Death Star', artist:'Cliff Chiang'},
      {n:'55', name:'Regrets', artist:'Jerry Vanderstelt'},
      {n:'56', name:'Palpatine Plays Possum', artist:'Mark McHaley'},
      {n:'57', name:'Rey The Scavenger', artist:'Andrew Fry'},
      {n:'58', name:"Luke's Ground Assault", artist:'Doug Cowan'},
      {n:'59', name:'Surveyed by the Dark Lord', artist:'Doug Cowan'},
      {n:'60', name:'The Battle of Hoth', artist:'Matt Busch'},
      {n:'61', name:'The Falcon Fires', artist:'Brian Rood'},
      {n:'62', name:'Endor Chase', artist:'Steve McNiven'},
      {n:'63', name:'A Sad Farewell', artist:'Chris Trevas'},
      {n:'64', name:'Reflections on Endor', artist:'Doug Cowan'},
      {n:'65', name:'The Dangers of Felucia', artist:'Doug Cowan'},
      {n:'66', name:'The Solitary Wicket', artist:'Doug Cowan'},
      {n:'67', name:'Gamorrean Guard', artist:'Jason Edminston'},
      {n:'68', name:'Offbeat Buddies', artist:'Steve Chorney'},
      {n:'69', name:'The Darkest Lord', artist:'Ed Repka'},
      {n:'70', name:'We are Bearing Gifts', artist:'Nathan Hamill'},
      {n:'71', name:'Curiosity Blasts Threepio', artist:'Matt Busch'},
      {n:'72', name:'Fall of a Jedi', artist:'Matt Busch'},
      {n:'73', name:'Focused And Fearless', artist:'Allison Sohn'},
      {n:'74', name:"Boba's Prize", artist:'Leinel Yu'},
      {n:'75', name:'Rancor Ranks Best of Beasts', artist:'Rob Dobi'},
      {n:'76', name:"Logray's Hunt", artist:'Patrick Schoenmaker'},
      {n:'77', name:'The Wrath of Maul', artist:'Russ Walks'},
      {n:'78', name:'The Finest on Naboo', artist:'Jerry Vanderstelt'},
      {n:'79', name:'The Rogue Years', artist:'Steve Chorney'},
      {n:'80', name:'Birth of a Hero', artist:'Steve Chorney'},
      {n:'81', name:'A Menace Named Maul', artist:'Joe Corroney'},
      {n:'82', name:'The Hopeful Princess', artist:'Doug Cowan'},
      {n:'83', name:"Vader's Revenge", artist:'Brian Rood'},
      {n:'84', name:'In the Court of the Evil Hutt', artist:'Patrick Schoenmaker'},
      {n:'85', name:'A Hutt Called Jabba', artist:'Ed Repka'},
      {n:'86', name:'Dueling with Dooku', artist:'Paul Shipper'},
      {n:'87', name:'Rites of Passage', artist:'William Silvers'},
      {n:'88', name:'Jedi a la Kurosawa', artist:'Randy Martinez'},
      {n:'89', name:'Dashing Derring-Do', artist:'Randy Martinez'},
      {n:'90', name:'The Karloff Connection', artist:'Randy Martinez'},
      {n:'91', name:'The Skywalker Saga: Luke', artist:'Carlos Cabaleiro'},
      {n:'92', name:'Student Becomes the Teacher', artist:'Randy Martinez'},
      {n:'93', name:'United behind General Grievous', artist:'Ben Abu Saada'},
      {n:'94', name:'Mos Eisley After Dark', artist:'Eric Lehtonen'},
      {n:'95', name:'Commander Poe Dameron', artist:'Paul Andrews'},
      {n:'96', name:'Light Rises to Meet Dark', artist:'Bob Stevlic'},
      {n:'97', name:'The Sand People', artist:'Kris Pennix'},
      {n:'98', name:"Thrawn's Private Quarters", artist:'Rich Molinelli'},
      {n:'99', name:'Stardust on Scarif', artist:'Todd Aaron Smith'},
      {n:'100', name:"The First Order's Enforcer", artist:'Joe Coronney'},
    ]
  },
  {
    id: 'visions-of-mandalore', type: 'insert', title: 'VISIONS OF MANDALORE — 10 CARDS',
    cards: [
      {n:'MN-1', name:'Visions of Mandalore 1'},{n:'MN-2', name:'Visions of Mandalore 2'},
      {n:'MN-3', name:'Visions of Mandalore 3'},{n:'MN-4', name:'Visions of Mandalore 4'},
      {n:'MN-5', name:'Visions of Mandalore 5'},{n:'MN-6', name:'Visions of Mandalore 6'},
      {n:'MN-7', name:'Visions of Mandalore 7'},{n:'MN-8', name:'Visions of Mandalore 8'},
      {n:'MN-9', name:'Visions of Mandalore 9'},{n:'MN-10', name:'Visions of Mandalore 10'},
    ]
  },
  {
    id: 'vintage-sw', type: 'insert', title: 'VINTAGE STAR WARS POSTERS — 15 CARDS',
    cards: [
      {n:'V-1', name:'Millennium Falcon'},
      {n:'V-2', name:'Hero Action Figures'},
      {n:'V-3', name:'Star Destroyer'},
      {n:'V-4', name:'Action Figures'},
      {n:'V-5', name:'Scout Trooper with Speeder Bike'},
      {n:'V-6', name:'Millennium Falcon'},
      {n:'V-7', name:'Death Star Racing Set'},
      {n:'V-8', name:'Darth Vader Helmet'},
      {n:'V-9', name:'Remote Control R2-D2'},
      {n:'V-10', name:'Death Star II'},
      {n:'V-11', name:'Villain Action Figures'},
      {n:'V-12', name:'Action Figure Order Form'},
      {n:'V-13', name:'T-65 X-wing Starfighter'},
      {n:'V-14', name:'Jabba the Hutt Playset'},
      {n:'V-15', name:'Millennium Falcon Scale Model'},
    ]
  },
  {
    id: 'global-posters', type: 'insert', title: 'STAR WARS GLOBAL POSTERS — 20 CARDS',
    cards: [
      {n:'GP-1', name:'Star Wars: The Empire Strikes Back – Sweden'},
      {n:'GP-2', name:'Star Wars: The Empire Strikes Back – Spain'},
      {n:'GP-3', name:'Star Wars: The Empire Strikes Back – China'},
      {n:'GP-4', name:'Star Wars: The Empire Strikes Back – France'},
      {n:'GP-5', name:'Star Wars: The Empire Strikes Back – Argentina'},
      {n:'GP-6', name:'Star Wars: The Empire Strikes Back – Japan'},
      {n:'GP-7', name:'Star Wars: The Empire Strikes Back – Italy'},
      {n:'GP-8', name:'Star Wars: The Empire Strikes Back – Brazil'},
      {n:'GP-9', name:'Star Wars: The Empire Strikes Back – Sweden'},
      {n:'GP-10', name:'Star Wars: Return of the Jedi – Japan'},
      {n:'GP-11', name:'Star Wars: A New Hope – Thailand'},
      {n:'GP-12', name:'Star Wars: A New Hope – Spain'},
      {n:'GP-13', name:'Star Wars: A New Hope – France'},
      {n:'GP-14', name:'Star Wars: Return of the Jedi – Poland'},
      {n:'GP-15', name:'Star Wars: Return of the Jedi – Spain'},
      {n:'GP-16', name:'Star Wars: A New Hope – France'},
      {n:'GP-17', name:'Star Wars: A New Hope – Israel'},
      {n:'GP-18', name:'Star Wars: A New Hope – Italy'},
      {n:'GP-19', name:'Star Wars: A New Hope – Poland'},
      {n:'GP-20', name:'Star Wars: A New Hope – USA'},
    ]
  },
  {
    id: 'auto-single', type: 'auto', title: 'GALAXY AUTOGRAPHS — 59 CARDS',
    cards: [
      {n:'GA-AB', name:'Anna Brewster'},{n:'GA-AD', name:'Adam Driver'},
      {n:'GA-AG', name:'Anna Graves'},{n:'GA-AND', name:'Annabelle Davis'},
      {n:'GA-AS', name:'Andy Serkis'},{n:'GA-ASG', name:'Arti Shah'},
      {n:'GA-AT', name:'Alan Tudyk'},{n:'GA-BB', name:'Blair Bess'},
      {n:'GA-BDW', name:'Billy Dee Williams'},{n:'GA-BL', name:'Billie Lourd'},
      {n:'GA-CDW', name:'Corey Dee Williams'},{n:'GA-CE', name:'Chris Edgerly'},
      {n:'GA-CF', name:'Carrie Fisher'},{n:'GA-CW', name:'Carl Weathers'},
      {n:'GA-DC', name:'Dermot Crowley'},{n:'GA-DMB', name:'Dominic Monaghan'},
      {n:'GA-DR', name:'Daisy Ridley'},{n:'GA-DT', name:'Dee Tails'},
      {n:'GA-DY', name:'Donnie Yen'},{n:'GA-EK', name:'Erin Kellyman'},
      {n:'GA-ES', name:'Emily Swallow'},{n:'GA-EW', name:'Ewan McGregor'},
      {n:'GA-FJ', name:'Felicity Jones'},{n:'GA-FW', name:'Forest Whitaker'},
      {n:'GA-GCP', name:'Gwendoline Christie'},{n:'GA-GE', name:'Giancarlo Esposito'},
      {n:'GA-GG', name:'Greg Grunberg'},{n:'GA-HC', name:'Hayden Christensen'},
      {n:'GA-HCT', name:'Hermione Corfield'},{n:'GA-HD', name:'Harley Durst'},
      {n:'GA-HF', name:'Harrison Ford'},{n:'GA-IK', name:'Ian Kenny'},
      {n:'GA-IR', name:'Ian Ruskin'},{n:'GA-JH', name:'Jessica Henwick'},
      {n:'GA-JK', name:'Jaime King'},{n:'GA-JR', name:'John Ratzenberger'},
      {n:'GA-JS', name:'Jason Spisak'},{n:'GA-JT', name:'John Tui'},
      {n:'GA-KB', name:'Kenny Baker'},{n:'GA-KMT', name:'Kelly Marie Tran'},
      {n:'GA-LD', name:'Laura Dern'},{n:'GA-MM', name:'Mads Mikkelsen'},
      {n:'GA-NA', name:'Naomi Ackie'},{n:'GA-NF', name:'Nika Futterman'},
      {n:'GA-NN', name:'Nick Nolte'},{n:'GA-OA', name:'Omid Abtahi'},
      {n:'GA-PAR', name:'Philip Anthony-Rodriguez'},{n:'GA-PM', name:'Peter Mayhew'},
      {n:'GA-PP', name:'Pedro Pascal'},{n:'GA-RA', name:'Riz Ahmed'},
      {n:'GA-RAD', name:'Robin Atkin Downes'},{n:'GA-RP', name:'Ray Park'},
      {n:'GA-SLJ', name:'Samuel L. Jackson'},{n:'GA-TD', name:'Tim Dry'},
      {n:'GA-TM', name:'Temuera Morrison'},{n:'GA-TW', name:'Taika Waititi'},
      {n:'GA-VK', name:'Valene Kane'},{n:'GA-WD', name:'Warwick Davis'},
      {n:'GA-WH', name:'Werner Herzog'},
    ]
  },
  {
    id: 'auto-dual', parallels: [{id:'red',name:'Red Refractor',print_run:5,color:'#ff1744'},{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'DUAL AUTOGRAPHS — 13 CARDS',
    cards: [
      {n:'DA-CB', name:'John Boyega / Gwendoline Christie', artist:'Finn / Phasma'},
      {n:'DA-CC', name:'Hermione Corfield / Crystal Clarke', artist:''},
      {n:'DA-EB', name:'Paul Bettany / Alden Ehrenreich', artist:'Dryden / Han'},
      {n:'DA-FB', name:'Brian Blessed / Oliver Ford Davies', artist:''},
      {n:'DA-FM', name:'Peter Mayhew / Harrison Ford', artist:'Chewie / Han'},
      {n:'DA-JM', name:'Mads Mikkelsen / Felicity Jones', artist:'Galen / Jyn'},
      {n:'DA-KE', name:'Ashley Eckstein / Jaime King', artist:''},
      {n:'DA-MB', name:'Ewan McGregor / Ahmed Best', artist:'Obi-Wan / Jar Jar'},
      {n:'DA-ML', name:'Temuera Morrison / Daniel Logan', artist:'Jango / Young Boba'},
      {n:'DA-NE', name:'Giancarlo Esposito / Werner Herzog', artist:'Moff / Client'},
      {n:'DA-RS', name:'Joonas Suotamo / Daisy Ridley', artist:'Chewie / Rey'},
      {n:'DA-SL', name:'Charlotte Louise / Sema-Tawi Smart', artist:''},
      {n:'DA-TE', name:'George Takei / Ashley Eckstein', artist:''},
    ]
  },
  {
    id: 'auto-triple', parallels: [{id:'superfractor',name:'Superfractor',print_run:1,color:'#f0c040'}], type: 'auto', title: 'TRIPLE AUTOGRAPHS — 10 CARDS',
    cards: [
      {n:'TA-DSC', name:'Adam Driver / Andy Serkis / Gwendoline Christie', artist:'Kylo / Snoke / Phasma'},
      {n:'TA-EKD', name:'Alden Ehrenreich / Warwick Davis / Erin Kellyman', artist:'Solo Cast'},
      {n:'TA-FET', name:'Jeremy Bulloch / Temuera Morrison / Daniel Logan', artist:'Boba Fetts'},
      {n:'TA-FWM', name:'Harrison Ford / Peter Mayhew / Billy Dee Williams', artist:'Han / Chewie / Lando'},
      {n:'TA-HFP', name:'Amanda Hale / Simon Paisley Day / Geff Francis', artist:''},
      {n:'TA-LHK', name:'Denis Lawson / Jack Klaff / Garrick Hagon', artist:'Wedge / Red Six / Red Three'},
      {n:'TA-MAC', name:'Tim Rose / Caroline Blakiston / Dermot Crowley', artist:'Ackbar / Mon Mothma / Madine'},
      {n:'TA-RBT', name:'Daisy Ridley / John Boyega / Kelly Marie Tran', artist:'Rey / Finn / Rose'},
      {n:'TA-WRQ', name:'Simon Williamson / Mike Quinn / Deep Roy', artist:''},
      {n:'TA-YKK', name:'Paul Kasey / Nick Kellington / Donnie Yen', artist:''},
    ]
  },
  {
    id: 'sketch', parallels: [], type: 'sketch', title: 'SKETCH CARDS',
    cards: [{n:'SK-1', name:'Sketch Card', artist:'Various Artists'}]
  },
];
export const PARALLELS = [
  { id: 'refractor', name: 'Refractor', print_run: null, color: '#c8d8f0' },
  { id: 'atomic', name: 'Atomic Refractor', print_run: 150, color: '#00bcd4' },
  { id: 'wave', name: 'Wave Refractor', print_run: 99, color: '#00b0ff' },
  { id: 'prism', name: 'Prism Refractor', print_run: 75, color: '#e040fb' },
  { id: 'mojo', name: 'Mojo Refractor', print_run: 50, color: '#ff6d00' },
  { id: 'purple', name: 'Purple Refractor', print_run: 25, color: '#b060ff' },
  { id: 'xfractor', name: 'X-Fractor', print_run: 10, color: '#76ff03' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const AUTO_PARALLELS = [
  { id: 'blue', name: 'Blue Refractor', print_run: 150, color: '#2979ff' },
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'purple', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
export const INSERT_PARALLELS = [
  { id: 'green', name: 'Green Refractor', print_run: 99, color: '#00e676' },
  { id: 'purple', name: 'Purple Refractor', print_run: 50, color: '#b060ff' },
  { id: 'orange', name: 'Orange Refractor', print_run: 25, color: '#ff9100' },
  { id: 'red', name: 'Red Refractor', print_run: 5, color: '#ff1744' },
  { id: 'superfractor', name: 'Superfractor', print_run: 1, color: '#f0c040' },
];
